import React, { useState, forwardRef } from "react";
import { Icon } from "semantic-ui-react";

export const CollapsibleSection = forwardRef(function CollapsibleSection(
  { title, header, children, defaultOpen = true, className = "" },
  ref
) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={className} ref={ref}>
      <div className="section-header" onClick={() => setIsOpen(!isOpen)}>
        {header || <span>{title}</span>}
        <Icon name={isOpen ? "chevron up" : "chevron down"} />
      </div>
      {isOpen && <div className="section-content">{children}</div>}
    </div>
  );
});
